(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode(`._header_m076r_1{z-index:3;background-color:#fff}._header_container_m076r_6{margin-bottom:2px}._neu-image_wrapper_m076r_10{max-width:100%;height:auto}._neu_image_wrapper_m076r_15{display:flex;align-items:center}@media (max-width: 576px){._neu_image_wrapper_m076r_15{justify-content:center;width:100%}}._neu_image_wrapper_m076r_15 .neu-image{margin:0 auto}
._top_navigation_container_br4ci_1{white-space:nowrap}._neu-dropdown_br4ci_5:hover{padding:var(--neu-spacer-2, 4px);border-radius:50%;color:var(--neu-blue-60)}._dropdown_items_br4ci_11{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._dropdown_items_active_br4ci_16{background-color:var(--link-pressed-background, #6a91af)}@media (max-width: 993px){._dropdown_container_br4ci_21{display:none}}@media (min-width: 993px){._mobile_menu_br4ci_27{display:none}}
._mhoTabsWrapper_1vsck_1{display:grid;grid-template-columns:1fr;gap:var(--neu-spacer-6, 24px);align-items:start;margin-top:var(--neu-spacer-3, .5rem)}@media (min-width: 768px){._mhoTabsWrapper_1vsck_1{gap:var(--neu-spacer-7, 32px);grid-template-columns:224px 1fr}}@media (min-width: 992px){._mhoTabsWrapper_1vsck_1{grid-template-columns:312px 1fr}}._mhoTabsWrapper_1vsck_1 ._noBackgroundTab_1vsck_19{background:none;box-shadow:none!important}._mhoTabsWrapper_1vsck_1 ._minH320_1vsck_23{min-height:320px}._mhoTabsWrapper_1vsck_1.neu-list{box-shadow:var(--neu-elevation-1) var(--neu-elevation-color)}
._certificationImageContainer_1gn0m_1{display:flex;justify-content:end;align-items:center;width:100%}@media (max-width: 660px){._certificationImageContainer_1gn0m_1{justify-content:center;width:100%;height:72px}}._certificationImageContainer_1gn0m_1>button>figure{margin:0}._imageContainer_1gn0m_19>figure{margin:0}._certificationButton_1gn0m_23{padding:var(--neu-spacer-0);background-color:transparent;min-width:auto;min-height:auto;border:none;text-align:center;cursor:pointer}._certificationButton_1gn0m_23:active,._certificationButton_1gn0m_23:focus,._certificationButton_1gn0m_23:hover{transform:scale(1.2);transition:transform .3s ease-in-out;background-color:transparent}._certificationButton_1gn0m_23:focus-visible{outline:revert;background-color:transparent}._modal_wrapper_3fxo4_1{max-height:600px}._modal_header_3fxo4_5{text-align:center}._modal_description_3fxo4_9{padding-top:20px;text-align:left;line-height:26px}._modal_description_3fxo4_9>p{line-height:26px}._modal_description_3fxo4_9>ul>li::marker{font-size:1.5em;font-weight:700}._modal_description_3fxo4_9>ul{padding-left:22px}._modal_image_3fxo4_28{width:200px}._footerSection_96jav_1{padding:70px 0 30px;background-color:#fff}@media (max-width: 768px){._footerSection_96jav_1{padding:30px var(--neu-spacing-0, 0px)}}._footerContainer_96jav_11{padding:var(--neu-spacing-0, 0) var(--neu-spacing-4, 12px);display:grid;grid-template-columns:1fr 1fr;grid-template-areas:"contact privacy" "links links"}@media (min-width: 1400px){._footerContainer_96jav_11{max-width:1320px}}@media (max-width: 660px){._footerContainer_96jav_11{align-items:center;grid-template-columns:1fr;grid-template-areas:"contact" "links" "privacy";place-items:center}}._contactArea_96jav_31{grid-area:contact}._logoImageContainer_96jav_35{display:flex;justify-content:start;padding-bottom:10px}@media (max-width: 660px){._logoImageContainer_96jav_35{justify-content:center;padding-bottom:var(--neu-spacing-6, 20px)}}._logoImageContainer_96jav_35>figure{margin:var(--neu-spacing-0, 0px)}._contactInfo_96jav_51{text-wrap:balance;text-align:center}@media (min-width: 768px){._contactInfo_96jav_51{text-align:start}}._linkArea_96jav_61{grid-area:links;display:flex;flex-direction:row;flex-wrap:wrap;align-items:center;justify-content:center;padding-block:var(--neu-spacing-6, 20px);gap:var(--neu-spacing-6, 20px)}@media (min-width: 1024px){._linkArea_96jav_61{justify-content:start}}@media (max-width: 660px){._linkArea_96jav_61{flex-direction:column;align-items:center;gap:10px}}._privacyArea_96jav_84{grid-area:privacy;display:grid;grid-template-areas:"certification-image" "privacy-info"}@media (min-width: 1024px){._privacyArea_96jav_84{column-gap:20px;grid-template-columns:1fr max-content;grid-template-areas:"privacy-info certification-image"}}@media (max-width: 660px){._privacyArea_96jav_84{column-gap:20px;align-items:center}}._privacyInfoContainer_96jav_103{grid-area:privacy-info;display:flex;flex-direction:column;align-items:end;padding-top:var(--neu-spacing-1, 2px)}@media (max-width: 660px){._privacyInfoContainer_96jav_103{padding:var(--neu-spacing-6, 20px);align-items:center;text-align:center}}@media (min-width: 1024px){._privacyInfoContainer_96jav_103{justify-content:center}}._privacyInfo_96jav_103{text-wrap:balance;text-align:center}@media (min-width: 768px){._privacyInfo_96jav_103{text-align:end}}
._mho_alert_wrapper_1lqun_1 .neu-snackbar{--snackbar-radius: 0}
._table_usmlv_1 th{border-top:none;padding:var(--neu-spacing-4, .75rem) 0 var(--neu-spacing-3, .5rem)}._table_usmlv_1 th:not(:last-of-type){width:50%}@media (min-width: 360px){._table_usmlv_1 th:not(:last-of-type){width:60%}}@media (min-width: 576px){._table_usmlv_1 th:not(:last-of-type){width:70%}}@media (min-width: 992px){._table_usmlv_1 th:not(:last-of-type){width:37.5%}}@media (min-width: 1200px){._table_usmlv_1 th:not(:last-of-type){width:40%}}@media (max-width: 480px){._table_usmlv_1 th:not(:last-of-type) h3{white-space:normal!important}}._table_usmlv_1 td{padding:var(--neu-spacing-4, .75rem) 0;max-width:0}._table_usmlv_1 td p{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._table_usmlv_1 tr:last-of-type>td{border-bottom:none}._table_usmlv_1 tfoot{border-top:1px solid var(--table-border)}@media (max-width: 992px){._table_usmlv_1 th{padding:var(--neu-spacing-1, .125rem) 0}._table_usmlv_1 td{padding:var(--neu-spacing-3, .5rem) 0}}._table_usmlv_1 tbody tr:hover :is(th,td){background:var(--table-background)!important}._description_usmlv_64 p,._item_usmlv_65 p{margin:0}._description_usmlv_64>td,._item_usmlv_65>td{border-top:none}._item_usmlv_65>td:first-of-type{max-width:75px}@media (min-width: 576px){._item_usmlv_65>td:first-of-type{max-width:85px}}@media (min-width: 992px){._item_usmlv_65>td:first-of-type{max-width:110px}}._item_usmlv_65>td:last-of-type{width:auto;max-width:none}._description_usmlv_64>td{padding-top:0}._headerRowWithDescription_usmlv_99 th{padding:0;border-bottom:none}._headerRowWithDescription_usmlv_99+tr>td{padding:0;padding-bottom:var(--neu-spacing-3, .5rem);border-top:none}
._formInput_tgf87_1 button{text-align:left}._divider_23elx_1{width:100%;height:1px}
._card_items_1xzq2_1{text-decoration:none;border-top:1px solid var(--neu-gray-30, #b0b0b0)}._card_items_1xzq2_1:hover,._card_items_1xzq2_1:focus{background-color:var(--neu-gray-10, #e2e2e2)}._card_items_1xzq2_1:active{background-color:var(--neu-blue-10, #d3e5f2)}@media (min-width: 768px){._card_items_1xzq2_1._header_link_1xzq2_12{display:none}}._link_icon_container_1xzq2_17{width:var(--neu-spacer-6, 1.5rem);text-align:center}._link_icon_container_1xzq2_17>figure{margin:0}._userEmail_std5a_1{text-overflow:ellipsis;max-width:284px}._profileCardContainer_std5a_6{padding-left:1.5rem}._profileCardContainer_std5a_6 .neu-dropdown--menu{max-width:284px!important;transform:translate3d(2px,23px,0)!important}@media (max-width: 660px){._profileCardContainer_std5a_6 .neu-dropdown--menu{inset:0px 0px auto auto;transform:translate3d(4px,23px,0)}}._profileCardContainer_std5a_6 .neu-dropdown--menu ul{max-height:none!important}._profileCardContainer_std5a_6 .neu-dropdown--menu li,._profileCardContainer_std5a_6 .neu-dropdown--menu a{width:284px!important}._profileCardContainer_std5a_6 .neu-dropdown--menu a:hover{color:var(--neu-gray-100)}._firstName_std5a_31{font-size:20px!important;text-overflow:ellipsis;max-width:284px}
._description_35t4d_1 p{margin:0}@media (min-width: 768px){._addLinkForm-input1_35t4d_6{width:33%}}@media (min-width: 768px){._addLinkForm-input2_35t4d_12{width:66%}}._disclaimerText_35t4d_17{line-height:1.125rem}
._formInput_ffgvo_1{display:flex;align-items:center;width:var(--custom-width, 100%)}._card_1b673_1{width:100%;aspect-ratio:3/1.8;border:3px dashed rgb(var(--neu-gray-10-light, 226, 226, 226));background-color:rgb(var(--neu-plain-0-light, 255, 255, 255));border-radius:var(--neu-border-radius-default, 8px);overflow:hidden}._card_1b673_1:has(input:focus){border-color:rgb(var(--neu-gray-20-light, 226, 226, 226))}@media (min-width: 769px){._card_1b673_1{max-height:220px}}._icon_1b673_18{font-size:2.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin-bottom:10px}._cardTitletext_1b673_24{font-size:1.25rem;color:rgb(var(--neu-blue-70-light, 0, 90, 141));margin:0;padding:5px 0}@media (max-width: 576px){._cardTitletext_1b673_24{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._description_1b673_39{font-size:var(--neu-font-size, 1rem);color:rgb(var(--neu-gray-10-dark, 31, 31, 31));margin:0}@media (max-width: 576px){._description_1b673_39{width:100%;padding-left:var(--neu-spacer-3, .5rem);padding-right:var(--neu-spacer-3, .5rem);text-align:center}}._alertError_1b673_53{padding:var(--neu-spacer-4, .75rem);text-align:center;margin-top:var(--neu-spacer-5, 1rem);position:relative}._uploadedImageWrapper_1b673_60{width:100%;height:100%}._uploadedImage_1b673_60{width:100%;height:100%;position:relative;transform:translate(-50%,-50%);top:50%;left:50%}._uploadedImage_1b673_60 figure{width:100%;height:100%;margin:0}._uploadedImage_1b673_60 figure div{height:100%;width:100%}._uploadedImage_1b673_60 figure img{width:100%;height:100%;object-fit:contain}._reuploadMessage_1b673_88{position:absolute;bottom:0;left:0;color:#fff!important;background:#00000080;width:100%;text-align:center;padding:5px 0;display:none!important;z-index:10}._uploadedContainer_1b673_101{position:relative;width:100%;height:100%}._uploadedContainer_1b673_101:focus,._uploadedContainer_1b673_101:hover>div._reupload_message_1b673_106{display:block!important}._fileInput_1b673_110{height:1px;width:1px;opacity:0;position:absolute}
._formItem_r52t0_1{flex:1}
._linkField_kas8y_1{min-width:fit-content;padding-top:var(--neu-spacing-2, .25rem)}._text_field_1gmpc_1 p{margin:0}@media (max-width: 768px){._image_field_1gmpc_7{height:6.25rem;width:6.25rem}}._divider_h91qf_1{height:1px;transform:translateY(-21px)}
._modalContentContainer_10hs1_1{max-height:90vh;overflow:auto}@media (max-width: 475px){._modalContentContainer_10hs1_1{max-height:85vh}}
._description_1nfzp_1 p{margin:0}._searchItem_1nfzp_5{background-color:var(--neu-plain-0, #fff)}._noItemErrorMessage_1nfzp_9 ul li::marker{color:var(--neu-plain-100, #000)}
._horizontalTabsWrapper_lulv0_1{display:flex;width:100%}._horizontalTabsWrapper_lulv0_1 .unit-tab{flex:1 1 0;min-width:0;align-items:center;justify-content:center}._horizontalTabsWrapperSc_lulv0_12{padding-left:0;padding-right:0}._horizontalTabsCard_lulv0_17 .unit-content{padding:0}
._imageContainer_1xsj3_1{margin:16px 0;position:relative;min-height:104px;min-width:104px;height:fit-content;width:fit-content}._editButton_1xsj3_10{position:absolute;bottom:0;right:0;background-color:var(--neu-gray-10, "#e2e2e2")!important}._fileInput_1xsj3_17{width:1px;height:1px;display:none}._formItemPreferredFacilityState_1eisr_1{width:100%!important;min-width:50%!important;flex:1}@media screen and (min-width: 960px){._formItemPreferredFacilityState_1eisr_1{flex:.2;max-width:140px!important;min-width:140px!important}}._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{width:100%!important;padding-right:24px!important}@media screen and (max-width: 380px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:265px!important}}@media screen and (min-width: 381px) and (max-width: 575px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:305px!important}}@media screen and (min-width: 576px) and (max-width: 820px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:196px!important}}@media screen and (min-width: 821px) and (max-width: 1024px){._formItemPreferredFacility_1eisr_1 .neu-select--placeholder .placeholder-wrapper{max-width:320px!important}}`)),document.head.appendChild(e)}}catch(t){console.error("vite-plugin-css-injected-by-js",t)}})();
import { jsx as r, jsxs as F } from "react/jsx-runtime";
import { useFormContext as M, Controller as R, FormProvider as I } from "react-hook-form";
import { NeuInput as _, NeuSelect as B, NeuModal as $, NeuFeedback as j } from "@hcahealthcaredpx/neutron-react";
import { c as x } from "./clsx.OuTLNxxd.js";
import { i as W, M as A } from "./page-content.B0ugSU6N.js";
import { useState as E, useRef as U, useEffect as T, useId as z } from "react";
import { u as V } from "./useNetworkStatus.B65eRjoK.js";
import { M as k } from "./mho-action-buttons.fY1B40h9.js";
import { useRouter as Y } from "next/router";
const ue = ({
  name: e,
  label: t = "",
  labelHidden: l = !1,
  triggerValidationOnChange: s = !1,
  debounce: m = 0,
  tip: i,
  required: a,
  maxLength: o = 100,
  showInlineError: n = !0,
  showErrorOutline: c = !0,
  ...p
}) => {
  var g;
  const {
    control: u,
    trigger: d,
    formState: { errors: v }
  } = M(), f = (g = v == null ? void 0 : v[e]) == null ? void 0 : g.message;
  return /* @__PURE__ */ r(
    R,
    {
      name: e,
      control: u,
      render: ({ field: h }) => /* @__PURE__ */ r("div", { className: "w-100", children: /* @__PURE__ */ r(
        _,
        {
          label: t,
          value: h.value,
          onChange: (b) => {
            h.onChange(b.target.value), s && d(e);
          },
          onNeuBlur: () => d(e),
          labelHidden: l,
          debounce: m,
          tip: i,
          required: a,
          invalid: n ? f : null,
          error: n || c ? !!f : null,
          maxLength: o,
          ...p
        }
      ) })
    }
  );
}, q = "_formInput_tgf87_1", G = {
  formInput: q
}, de = ({
  name: e,
  addNullItem: t = !0,
  nullItemValue: l = "",
  nullItemLabel: s = "Select",
  debounce: m = 0,
  kind: i = "single",
  color: a = "blue",
  formOnChange: o,
  triggerValidationOnChange: n = !1,
  items: c,
  className: p,
  disabled: u,
  showInlineError: d = !0,
  showErrorOutline: v = !0,
  ...f
}) => {
  var N;
  const {
    control: g,
    trigger: h,
    formState: { errors: b }
  } = M(), w = [
    ...t ? [{ value: l, label: s }] : [],
    ...c
  ];
  if (W(c))
    return /* @__PURE__ */ F("div", { className: "w-100 d-flex flex-column ", style: { gap: "4px" }, children: [
      /* @__PURE__ */ r(
        "label",
        {
          htmlFor: `combobox-${e}`,
          className: x("neu-text-caption", u && "neu-text-gray-30 "),
          children: f.label
        }
      ),
      /* @__PURE__ */ r(
        "div",
        {
          className: x(
            "border pl-2",
            u ? "neu-bg-gray-10 neu-text-gray-40" : "neu-bg-plain-0 "
          ),
          style: {
            height: "40px",
            borderRadius: "8px",
            fontWeight: "normal",
            borderColor: u ? "#E2E2E2" : "#858585",
            paddingLeft: "12px",
            paddingTop: "2px",
            display: "flex",
            alignItems: "center"
          },
          children: /* @__PURE__ */ r(
            "span",
            {
              id: `combobox-${e}`,
              role: "combobox",
              "aria-disabled": u,
              "aria-expanded": "false",
              "aria-haspopup": "listbox",
              "aria-label": f.label || s,
              children: t ? s : f.label
            }
          )
        }
      )
    ] });
  const S = (N = b == null ? void 0 : b[e]) == null ? void 0 : N.message;
  return /* @__PURE__ */ r(
    R,
    {
      name: e,
      control: g,
      render: ({ field: C }) => /* @__PURE__ */ r(
        B,
        {
          ...f,
          items: w,
          color: a,
          debounce: m,
          kind: i,
          value: w.find(({ value: y }) => y === C.value),
          onNeuChange: (y) => {
            C.onChange(y.value), o == null || o(y.value), n && h(e);
          },
          onNeuBlur: () => h(e),
          invalid: d ? S : null,
          error: d || v ? !!S : null,
          disabled: u,
          className: x("w-100", G.formInput, p)
        }
      )
    }
  );
}, H = "_divider_23elx_1", L = {
  divider: H
}, J = ({ className: e, ...t }) => /* @__PURE__ */ r(
  "hr",
  {
    className: t.color ? x(t.color, L.divider, e) : x("neu-bg-gray-70", L.divider, e),
    "aria-hidden": !0,
    ...t
  }
), K = ({
  isToBeConfirmed: e
}) => {
  const [t, l] = E(!1), [s, m] = E(!1), i = U(null), a = Y();
  return T(() => {
    const o = (c) => {
      if (e && !s)
        throw l(!0), i.current = c, a.events.emit("routeChangeError"), "Route change aborted.";
    }, n = (c) => {
      e && c.preventDefault();
    };
    return window.addEventListener("beforeunload", n), a.events.on("routeChangeStart", o), () => {
      a.events.off("routeChangeStart", o), window.removeEventListener("beforeunload", n);
    };
  }, [e, s, a]), T(() => {
    if (s && i.current) {
      let o = i.current;
      i.current = null, m(!1), l(!1);
      const n = a.basePath || "";
      n && o.startsWith(n) && (o = o.slice(n.length) || "/"), a.push(o);
    }
  }, [s, a]), { showModal: t, setShowModal: l, setLeaveForm: m };
}, Q = ({
  formId: e,
  label: t,
  text: l,
  saveLabel: s,
  discardLabel: m
}) => {
  const {
    trigger: i,
    reset: a,
    formState: { isValid: o, isDirty: n }
  } = M(), { showModal: c, setLeaveForm: p, setShowModal: u } = K({
    isToBeConfirmed: n
  }), d = document.getElementById(e);
  return d ? /* @__PURE__ */ F($, { active: c, label: t, size: "medium", onNeuDismiss: () => {
    u(!1), p(!1);
  }, children: [
    /* @__PURE__ */ r("p", { className: "m-3", children: l }),
    /* @__PURE__ */ r(
      k,
      {
        primaryText: s,
        primaryType: "submit",
        onPrimaryClick: () => {
          o ? (p(!0), d == null || d.dispatchEvent(new Event("submit", { cancelable: !0, bubbles: !0 }))) : (i(), u(!1));
        },
        secondaryText: m,
        onSecondaryClick: () => {
          a(), p(!0);
        },
        buttonsAlignment: "end",
        wrapperClassName: "mx-3 mb-4"
      }
    )
  ] }) : null;
}, X = ({
  methods: e,
  children: t,
  onSubmit: l,
  onCancel: s,
  padding: m = "px-3",
  rowGap: i = 3,
  className: a,
  showButtons: o = !0,
  submitButtonText: n = "Save",
  isSubmitDisabled: c = !1,
  secondaryIcon: p,
  primaryIcon: u,
  isFullWidthSubmitButton: d = !1,
  actionBarClassName: v,
  cancelButtonText: f,
  buttonsAlignment: g = "start",
  isUnsavedChangesModalEnabled: h = !1,
  unsavedChangesModalTitle: b = "Unsaved changes",
  unsavedChangesModalText: w = "You have unsaved changes made on this page, which will be lost if you do not save. Would you like to save these changes?",
  unsavedChangesModalSaveLabel: S = "Save",
  unsavedChangesModalDiscardLabel: N = "Discard",
  isValidationTriggeredOnSubmit: C = !0,
  ...y
}) => {
  const D = z(), { isOnline: P } = V();
  return /* @__PURE__ */ r(I, { ...e, children: /* @__PURE__ */ F(
    "form",
    {
      ...y,
      id: D,
      onSubmit: e.handleSubmit(l),
      className: x(
        `position-relative w-100 d-flex flex-column row-gap-${i}`,
        m,
        a
      ),
      children: [
        h && /* @__PURE__ */ r(
          Q,
          {
            formId: D,
            label: b,
            text: w,
            saveLabel: S,
            discardLabel: N
          }
        ),
        t,
        o && /* @__PURE__ */ r(
          k,
          {
            onPrimaryClick: C ? () => e.trigger() : void 0,
            buttonsAlignment: g,
            primaryType: "submit",
            primaryText: n,
            primaryStyles: d ? "w-100" : "w-fit",
            isPrimaryDisabled: c || !P,
            secondaryText: f,
            secondaryIcon: p,
            primaryIcon: u,
            onSecondaryClick: s,
            wrapperClassName: v
          }
        )
      ]
    }
  ) });
}, Z = ({ title: e, showDivider: t = !0 }) => /* @__PURE__ */ F("div", { className: "w-100 d-flex flex-column gap-1", children: [
  /* @__PURE__ */ r(A, { level: "3", marginBottom: "0", className: "fw-heavy neu-display-6", children: e }),
  t && /* @__PURE__ */ r(J, { className: "my-0" })
] }), O = ({ children: e, columnGap: t = 3, className: l }) => /* @__PURE__ */ r(
  "div",
  {
    className: x(
      `w-100 d-flex flex-column flex-sm-row row-gap-2 column-gap-${t}`,
      l
    ),
    children: e
  }
), ee = ({ isPending: e, ...t }) => e ? /* @__PURE__ */ r("div", { className: "position-absolute top-0 w-100 bottom-0 d-flex justify-content-center align-items-center", children: /* @__PURE__ */ r(j, { ...t }) }) : null, me = Object.assign(X, {
  SectionTitle: Z,
  Row: O,
  Loader: ee
});
export {
  J as D,
  me as F,
  ue as a,
  de as b
};
